import axios from "axios";
import {AuthService} from "./authService";

const MAX_RETRIES = 5;
const RETRY_DELAY = 1000;

const setAuthInterceptor = function () {
  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response && error.response.status === 401) {
        AuthService.logOut();
      }
      if (isNetworkOrIdempotentRequestError(error)) {
        const config = error.config;
        config.retryCount = config.retryCount || 0;

        if (config.retryCount < MAX_RETRIES) {
          config.retryCount += 1;
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve(axios(config));
            }, RETRY_DELAY);
          });
        }
      }
      console.log(JSON.stringify(error));
      return Promise.reject(error);
    }
  );
};

function isNetworkOrIdempotentRequestError(error) {
  if (error.code === 'ECONNABORTED' || error.message === 'Network Error') {
    return true;
  }

  if (error.response && (error.response.status === 429 || error.response.status >= 500)) {
    return true;
  }

  return false;
}

export default setAuthInterceptor;


// WEBPACK FOOTER //
// ./src/service/axiosInterceptors.js